import { Injectable } from '@angular/core';
import { filter, Observable, switchMap, tap } from 'rxjs';
import { ChecklistRestService } from './checklist-rest.service';
import { Checklist } from './checklist.domain';

@Injectable()
export class ChecklistService {

  showFractionalCoachmark: boolean = false;
  showNonFractionalCoachmark: boolean = false;

  constructor(private checklistRestService: ChecklistRestService) {}

  getChecklist(isFractionalTradingEligible: boolean, displayCalculator: boolean = false): Observable<unknown> {
    return this.checklistRestService.getChecklist().pipe(
      tap((checklist: Checklist) => {
        this.showFractionalCoachmark = !checklist?.fractionalCoachMarkDisplayed && isFractionalTradingEligible && displayCalculator;
        this.showNonFractionalCoachmark = !checklist?.nonFractionalCoachMarkDisplayed && checklist?.fractionalCoachMarkDisplayed
          && !isFractionalTradingEligible;
      }),
      filter(() => this.showFractionalCoachmark || this.showNonFractionalCoachmark),
      switchMap((checklist: Checklist) => {
        const params = {
          fractionalCoachMarkDisplayed: checklist.fractionalCoachMarkDisplayed || this.showFractionalCoachmark,
          nonFractionalCoachMarkDisplayed: checklist.nonFractionalCoachMarkDisplayed || this.showNonFractionalCoachmark,
          dripsTabCoachmarkDisplayed: checklist.dripsTabCoachmarkDisplayed,
          dripsEligibilityCoachmarkDisplayed: checklist.dripsEligibilityCoachmarkDisplayed
        };
        return this.checklistRestService.updateCoachmarkChecklist(params);
      })
    );
  }

}
